import React from 'react'
import PropTypes from 'prop-types'
import CurrencySelector from 'components/CurrencySelector'
import MarketingBanner from 'components/MarketingBanner'
import styles from './styles'

const ListHeader = ({ totalCandidates, currencies, setDisplayedCurrency, displayedCurrency, filtersSelected }) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.numText}>
        {Object.keys(filtersSelected).length === 0 ? (
          <p className={styles.boldText}>{totalCandidates} developers are actively looking, right now</p>
        ) : (
          <p className={styles.boldText}>{totalCandidates} candidates match your filters</p>
        )}
      </div>
      {totalCandidates && process.env.NEXT_PUBLIC_ENABLE_GATED_CONTENT_BANNER === '1' ? <MarketingBanner /> : undefined}
      <div className={styles.subText}>
        <CurrencySelector currencies={currencies} setDisplayedCurrency={setDisplayedCurrency} displayedCurrency={displayedCurrency} />
      </div>
    </div>
  )
}

ListHeader.propTypes = {
  totalCandidates: PropTypes.number,
  currencies: PropTypes.arrayOf(PropTypes.object),
  setDisplayedCurrency: PropTypes.func,
  displayedCurrency: PropTypes.object,
  filtersSelected: PropTypes.object,
}

export default ListHeader
